import { TickIcon } from '@ps/web-shared-components';
import React from 'react';
import type { Accessor } from 'react-table';

import type { Tournament } from '@swf/poker';

import styles from './SortByOption.scss';

type OptionId = Accessor<Tournament> | string;

export interface SortByOptionProps {
  id: OptionId;
  desc: boolean;
  label: React.ReactNode;
  isSelected: boolean;
  onClick: ({ id, desc }: { id: string; desc: boolean }) => void;
}

const SortByOption: React.FC<SortByOptionProps> = ({ id, desc, label, onClick, isSelected }) => (
  <div className={styles.row} onClick={() => onClick({ id: String(id), desc })}>
    {isSelected && <TickIcon className={styles.tickIcon} />}
    <span className={styles.text}>{label}</span>
  </div>
);

export default SortByOption;
